import type { Investigation } from '@litlingo/client';
import LinkLookup from 'components/LinkLookup';
import usePushInvestigationToEpiq from 'hooks/investigations/usePushInvestigationToEpiq';
import React, { useState } from 'react';
import daysAgo from 'components/utils/daysAgo';

type ComponentProps = {
  investigation: Investigation;
};

const InvestigationListRow: React.FC<ComponentProps> = ({ investigation }) => {
  const { mutateAsync: pushToEpiqu } = usePushInvestigationToEpiq();
  const [isPushing, setIsPushing] = useState(false);

  const handlePushClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();
    e.preventDefault();
    setIsPushing(true);
    pushToEpiqu(investigation.uuid)
      .catch(() => undefined)
      .finally(() => setIsPushing(false));
  };

  return (
    <LinkLookup
      routeName="investigation-detail"
      routeParams={{ investigationId: investigation.uuid }}
      className="table-wrapper__tbody-tr border-t border-gray-200 hover:bg-gray-100 table-row cursor-pointer"
      as="tr"
      data-testid={`investigation-row-${investigation.uuid}`}
    >
      <td className="table-wrapper__tbody-td table-wrapper__td--w-30 pl-4">
        <span className="text-body text-litlingo-gray-6 font-medium">{investigation.name}</span>
      </td>
      <td className="table-wrapper__tbody-td">
        <span className="text-body text-litlingo-gray-5 line-clamp-2">
          {investigation.description ?? '—'}
        </span>
      </td>
      <td className="table-wrapper__tbody-td">
        <span className="text-body text-litlingo-gray-5">{investigation.discover_id ?? '—'}</span>
      </td>
      <td className="table-wrapper__tbody-td">
        <span className="text-body text-litlingo-gray-5">
          {investigation.updated_at ? daysAgo(investigation.updated_at) : '—'}
        </span>
      </td>
      <td className="table-wrapper__tbody-td h-8">
        <button
          type="button"
          className="button button--secondary h-6 shadow-sm rounded  "
          data-testid={`push-investigation-${investigation.uuid}`}
          onClick={handlePushClick}
          disabled={isPushing}
        >
          {isPushing ? 'Pushing…' : 'Push to Epiq'}
        </button>
      </td>
    </LinkLookup>
  );
};

export default InvestigationListRow;
